// extracted by mini-css-extract-plugin
export var container = "simple-text-module--container--5bbd0";
export var simpleText = "simple-text-module--simpleText--d674e";